<template>
  <div class="oai-GoalsStep">
    <OnboardingAiStepHeader
      :subtitle="$t('onboarding.ai.goals.subtitle')"
      :wizard-step="wizardStep"
      title-key-path="onboarding.ai.goals.title_prefix"
      title-key-name="meWith"
      :title-key-accent="$t('onboarding.ai.goals.title_accent')"
    />

    <div class="oai-GoalsStep_Options">
      <AppCheckbox
        v-for="option in ONBOARDING_AI_GOAL_OPTIONS"
        :key="option.id"
        v-model="selectedGoals"
        :label="$t(option.labelKey)"
        :class="{
          'oai-GoalChip-selected': selectedGoals.includes(option.id)
        }"
        class="oai-GoalChip oai-GoalChip_Checkbox"
        :value="option.id"
        full-width
        @update:model-value="onUpdateSelectedGoals"
      >
        {{ $t(option.labelKey) }}
      </AppCheckbox>
    </div>

    <OnboardingAiStepActions :disable="!canProceed" @next="onNext" />
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue'

import { ONBOARDING_AI_GOAL_OPTIONS } from '@/composables/onboarding-ai-step'
import { useOnboardingAiTracking } from '@/composables/onboarding-ai-step'
import { EVENT_NAMES } from '@/tracking/amplitude-helpers'

import AppCheckbox from '@/components/ui/AppCheckbox/AppCheckbox'
import OnboardingAiStepActions from '@/components/ui/onboarding-ai/OnboardingAiStepActions'
import OnboardingAiStepHeader from '@/components/ui/onboarding-ai/OnboardingAiStepHeader'

defineOptions({
  name: 'OnboardingAiGoalsStep'
})

defineProps({
  wizardStep: {
    type: Number,
    required: true
  }
})

const emit = defineEmits({
  next: null
})

const { logEvent } = useOnboardingAiTracking()

const selectedGoals = defineModel({ type: Array, default: () => [] })

const canProceed = computed(() => selectedGoals.value.length > 0)

const onNext = () => {
  emit('next')
}

const onUpdateSelectedGoals = value => {
  logEvent(EVENT_NAMES.ONBOARDING_PURPOSE_CLICKED, {
    goal: value
  })
}

onMounted(() => {
  logEvent(EVENT_NAMES.ONBOARDING_PURPOSE_VIEWED)
})
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/onboarding-ai-step';

.oai-GoalsStep {
  @extend %oai-wizard-step-shell;
}

.oai-GoalsStep_Options {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 4px;
  width: 100%;
  padding-block: 16px;
  align-items: flex-start;
}

.oai-GoalChip {
  border: 1px solid #cfd6e2;
  border-radius: 16px;
  background: $white;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  --ob-ac-checkbox-label-padding: 12px;

  &:hover {
    border-color: $grey-1-next;
  }

  &-selected {
    border-color: $primary-color-next;
    background: #0052cc0a;
  }
}

.oai-GoalChip_Checkbox {
  --line-height: 20px;
  --label-color: #{$dark-grey};
}
</style>
